export enum TenantPortalFieldsEnum {
  ID = 'id',
  UUID = 'uuid',
  SUBDOMAIN = 'subdomain',
  COMPANY_ID = 'companyId',
  COMPANY = 'company',
  ENABLED = 'enabled',
  DEFAULT_LANGUAGE_CODE = 'defaultLanguageCode',
  LANGUAGES = 'languages',
  LOGO_IMAGE_URL = 'logoImageUrl',
  BANNER_IMAGE_URL = 'bannerImageUrl',
  FAV_ICON_IMAGE_URL = 'favIconImageUrl',
  PRIMARY_FOREGROUND = 'primaryForeground',
  PRIMARY_BACKGROUND = 'primaryBackground',
}

export interface TenantPortalLanguageContent {
  title: string;
  subtitle: string;
}

export type TenantPortalLanguages = {
  [key: string]: TenantPortalLanguageContent;
} | null;

export interface TenantPortal {
  id: number;
  uuid: string;
  subdomain: string;
  companyId: number;
  domainUpdatedAt: Date | null;
  bannerImageUpdatedAt: Date | null;
  logoImageUpdatedAt: Date | null;
  favIconImageUrlUpdatedAt: Date | null;
  themeUpdatedAt: Date | null;
  enabled: boolean;
  defaultLanguageCode: string | null;
  languages: TenantPortalLanguages;
  logoImageUrl: string | null;
  bannerImageUrl: string | null;
  favIconImageUrl: string | null;
  primaryForeground: string | null;
  primaryBackground: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export type TenantPortalsResponse = Array<Pick<TenantPortal, 'uuid' | 'subdomain' | 'enabled'>>;

export interface TenantPortalsState {
  tenantPortals: TenantPortalsResponse | null;
  getTenantPortals: AsyncActionTypes;
}
